import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IRiskLevelProposal } from "@portal/types/robot/IRiskLevelProposal";

/**
 * Component to provide data for the chart for the risk level page.
 * @param riskLevel
 * @param isDefaultLanguage
 * @returns an object with chart data.
 */
export const RiskLevelData = (riskLevel: IRiskLevelProposal | undefined, isDefaultLanguage: boolean) => {
  const sharesPercentage = riskLevel?.shares;
  const interestPercentage = riskLevel?.interest;
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return {
    chart: { type: "variablepie" },
    credits: { enabled: false },
    title: null,
    accessibility: { enabled: false },
    legend: { labelFormat: "{y}% {name}" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: { format: "<b>{point.name}</b>: {point.percentage:.1f}%" },
      },
    },
    tooltip: { pointFormat: "<b>{point.percentage:.1f}%</b>" },
    series: [
      {
        dataLabels: { enabled: false },
        minPointSize: 10,
        innerSize: "40%",
        zMin: 0,
        showInLegend: true,
        data: [
          { name: `${texts.SHARES}`, color: `var(--color-blueHighcharts)`, y: sharesPercentage, z: 80, legendIndex: 2 },
          { name: `${texts.INTEREST}`, color: `var(--color-yellow)`, y: interestPercentage, z: 80, legendIndex: 1 },
        ],
      },
    ],
  };
};
